<template>
  <div>
    <Transition
      enter-active-class="transition-opacity duration-200 motion-reduce:transition-none"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-200 motion-reduce:transition-none"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="modalDisplay"
        :class="{
          'lightbox-overlay fixed inset-0 z-[9999] flex items-center justify-center overflow-y-auto bg-[#656565d1] px-4 py-8 backdrop-blur-md max-md:pb-6 max-md:pt-10 max-md:[&_span]:max-w-full': true,
        }"
        @click.self="closeModal"
      >
        <div
          :class="{ 'my-auto max-w-[90%]': true }"
          role="dialog"
          aria-modal="true"
          aria-label="Image lightbox"
        >
          <div :class="{ 'relative pt-5': true }">
            <button
              type="button"
              :class="{
                'absolute -top-30px right-0 z-[2] inline-flex min-h-34px items-center justify-center gap-2 rounded-full border-3px border-[rgba(255,255,255,0.9)] bg-[#657476] px-14px pl-10px text-13px font-bold leading-none tracking-[0.07em] text-www-color-white transition-colors duration-200 max-md:-top-8': true,
                'hover:bg-[#006e09] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-[#00890b]': true,
              }"
              aria-label="Close image lightbox"
              @click="closeModal"
            >
              <PtcIcon
                :class="{
                  'text-www-color-white': true,
                }"
                name="ptc-close-menu"
              />
              <span>CLOSE</span>
            </button>

            <PtcPicture
              v-if="image?.asset"
              provider="sanity"
              format="webp"
              :src="image.asset._ref"
              :img-attrs="{
                class: {
                  'w-full max-h-[75vh] shadow-[0_34px_80px_-12px_rgba(20,30,50,0.4),0_8px_24px_rgba(20,30,50,0.18)]': true,
                },
              }"
              :modifiers="{
                crop: image.crop,
                hotspot: image.hotspot,
                ...(asIs ? { asIs: true } : {}),
              }"
              loading="eager"
            />
          </div>

          <p
            v-if="caption"
            :class="{
              'mx-auto mt-4 max-w-830px px-5 text-center text-15px font-medium leading-[1.45] text-www-color-white': true,
            }"
          >
            {{ caption }}
          </p>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import type { ImageAtom } from '~/sanity/types.ts';
import PtcIcon from '../PtcIcon/PtcIcon.vue';
import PtcPicture from '../PtcPicture/PtcPicture.vue';

defineProps<ImageAtom>();
const modalDisplay = defineModel<boolean>();
const closeModal = () => {
  modalDisplay.value = false;
};
const handleKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Escape' && modalDisplay.value) {
    closeModal();
  }
};

onMounted(() => {
  document.addEventListener('keydown', handleKeydown);
});
</script>

<style scoped></style>
